import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
    {
        url_id: "/list/kelola-nasabah/kelola-kartu-debit-visa",
        url_path: "/list/kelola-nasabah/kelola-kartu-debit-visa",
    },
    {
        url_id: "/list/kelola-nasabah/kelola-kartu-debit-visa",
        url_path: "/form/kelola-nasabah/kelola-kartu-debit-visa",
    },
    {
        url_id: "/list/persetujuan/kelola-kartu-debit-visa",
        url_path: "/list/persetujuan/kelola-kartu-debit-visa",
    },
    {
        url_id: "/list/persetujuan/kelola-kartu-debit-visa",
        url_path: "/form/persetujuan/kelola-kartu-debit-visa",
    },
];
